import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { noop, useIsomorphicLayoutEffect, useResizeAware } from '@wp-g2/utils';
export function usePopoverResizeUpdater(_ref) {
  var _ref$onResize = _ref.onResize,
      onResize = _ref$onResize === void 0 ? noop : _ref$onResize;

  var _useResizeAware = useResizeAware(),
      _useResizeAware2 = _slicedToArray(_useResizeAware, 2),
      resizeListener = _useResizeAware2[0],
      sizes = _useResizeAware2[1];

  useIsomorphicLayoutEffect(function () {
    onResize();
  }, [sizes.width, sizes.height]);
  return resizeListener;
}